// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2H15L","header":"ClearentDisclaimer_header__Xer_e","inner":"ClearentDisclaimer_inner__f_YLD"};